module.exports = __webpack_public_path__ + "img/mary-ann-shadd-cary.d21d7e3e.png";